import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

import { getHasWriteAccessInCurrentSale } from "selectors";

export const ReadOnly = ({ readOnly, showLock, children = null }) => {
  if (readOnly && showLock) {
    return <FontAwesomeIcon icon={faLock} />;
  } else if (!readOnly) {
    return children;
  } else {
    return null;
  }
};

export const CurrentSaleReadOnly = ({ showLock = false, children = null }) => {
  const readOnly = useSelector(
    (state: RootState) => !getHasWriteAccessInCurrentSale(state),
  );
  return (
    <ReadOnly readOnly={readOnly} showLock={showLock}>
      {children}
    </ReadOnly>
  );
};
